import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Fathom from "fathom-client";

export function FathomAnalytics() {
  const location = useLocation();
  const fathomId = import.meta.env.VITE_FATHOM_ID;

  useEffect(() => {
    if (!fathomId) return;

    Fathom.load(fathomId, {
      auto: false,
    });
  }, [fathomId]);

  useEffect(() => {
    if (!fathomId) return;

    Fathom.trackPageview();
  }, [fathomId, location.pathname, location.search]);

  return null;
}
